











import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import BottomTabbar from '@/components/next/BottomTabbar.vue';
import { getBaseInfo } from './api';

const baseUrl = 'QCJK0907';

@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {
  tabs: any[] = [
    {
      title: '活动规则',
      path: `/${baseUrl}/rule`,
      id: 1,
    },
    {
      title: '作品展示',
      path: `/${baseUrl}/home`,
      id: 2,
    },
    {
      title: '上传作品',
      path: `/${baseUrl}/save`,
      id: 3,
    },
    {
      title: '新闻动态',
      path: `/${baseUrl}/news`,
      id: 4,
    },
  ];
  activeTab = 0;
  baseInfo: any = {};

  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '与爱同行 为爱守护',
      url: location.href,
      subtitle: `青春健康主题宣传创意作品大赛`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '与爱同行 为爱守护',
        subtitle: `青春健康主题宣传创意作品大赛`,
        image: cover,
      });
    }
  }

  async created() {
    const index = this.tabs.findIndex((item: any) => {
      return item.path === this.$route.path;
    });
    this.activeTab = index > -1 ? index : 0;
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }
}
